module.exports = __webpack_public_path__ + "static/media/spin_wheel_circle.731c4078.png";